var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-1 pt-1 pb-2"},[_c('TrainingItem',{style:({
      width: _vm.params['style[width]'],
      height: 'auto',
      minHeight: _vm.params['style[height]'] || 'auto',
      maxWidth: '100%',
    }),attrs:{"trainingName":_vm.text,"training":_vm.buyable,"isEmbed":true},on:{"img-load":function($event){return _vm.$emit('load')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }